export default "__VITE_ASSET__JmT4pWmh__"